export default "__VITE_ASSET__Do3ZtCo1__"